import {
  PlaylistByIdQuery,
  PlaylistListDocument,
  TagsByPlaylistsDocument,
  UpdatePlaylistTagsMutationVariables,
  useUpdatePlaylistTagsMutation,
} from "../../types.g";

export function usePlaylistTags() {
  const [updatePlaylistTags] = useUpdatePlaylistTagsMutation();

  const updateTags = async (
    playlist: NonNullable<PlaylistByIdQuery["playlistById"]>,
    tags: string[],
  ) => {
    if (playlist?.draft) {
      const playlistTagsInput: UpdatePlaylistTagsMutationVariables = {
        input: {
          id: playlist.id,
          tags,
        },
      };

      await updatePlaylistTags({
        variables: playlistTagsInput,
        refetchQueries: [
          {
            query: TagsByPlaylistsDocument,
            variables: {
              spaceId: playlist.spaceId,
              tags,
              isShared: false,
            },
          },
          {
            query: PlaylistListDocument,
            variables: {
              spaceId: playlist.spaceId,
              tags,
            },
          },
        ],
      });
    }
  };

  return { updateTags };
}
